import { Axios } from '@src/app/context/Api/includes/Axios';
import { AlertSchema } from '@src/entities/Alert/includes/schemas';
import { AlertEntity } from '@src/entities/Alert/includes/types';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { AxiosHeaders, AxiosRequestConfig, AxiosResponse } from 'axios';
import { omit } from 'lodash';

import { SaveAlertSchema } from './includes/schema';
import { SaveAlertMutationPayload } from './includes/types';

interface CustomRequestHeaders extends AxiosHeaders {
  'x-api-endpoint': string;
}

/**
 * Mutation: SaveAlert
 *
 * Saves a single alert entity to the remote API using a PUT request.
 * Validates the request body and response using Zod schemas.
 * Logs errors and rethrows them for upstream handling.
 */
export const SaveAlert = async (payload: SaveAlertMutationPayload = ['Alert', 'SaveAlert']): Promise<AlertEntity> => {
  try {
    const [theApiKey, theMutationKey, thePayload] = payload;

    const body = omit(thePayload, ['id']);

    const requestArgs: AxiosRequestConfig = {
      baseURL: config('API_URL'),
      data: body,
      headers: { 'x-api-endpoint': `/alerts/${thePayload?.id}` } as CustomRequestHeaders,
      method: 'PUT',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    SaveAlertSchema.parse(body);

    const remoteResponse: AxiosResponse = await Axios.request(requestArgs);
    return AlertSchema.parse(remoteResponse.data);
  } catch (error) {
    logger.error('src/entities/Alert/api/requests/mutations/SaveAlert/SaveAlert.ts -> SaveAlert()', false, error);
    throw error;
  }
};
